import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(() => ({
  tooltip: {
    width: 220,
    borderRadius: 3,
    padding: "8px 16px",
    boxShadow: "0px 1px 6px 0px #0000004D",
    fontFamily: "Segoe UI",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "16px",
    letterSpacing: 0,
    backgroundColor: "#fff",
    color: "#1E1E1E"
  },
  arrow: {
    width: 12,
    height: 6,
    color: "#fff",
    marginBottom: "-6px !important",
    overflow: "hidden",
    borderRadius: 2,
    "&::before": {
      boxShadow: "0px 1px 4px 0px #0000004D"
    }
  }
}));

export const CustomTooltip: React.FC<TooltipProps> = ({
  children,
  arrow = true,
  placement = "top",
  title,
  ...props
}) => {
  const classes = useStyles();
  if (!title) return children;
  return (
    <Tooltip
      placement={placement}
      arrow={arrow}
      title={title}
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};
